import _ from 'lodash'

EmptyPartLocationsDataSource.vsName = 'EmptyPartLocationsDataSource'
EmptyPartLocationsDataSource.vsNgType = 'factory'

EmptyPartLocationsDataSource.$inject = ['slotTrakPartsServer']
function EmptyPartLocationsDataSource(slotTrakPartsServer) {
  return function (query) {
    var self = this
    self.getRows = getRows
    self.pageSize = 10 

    function getRows(params) {
      const apiQuery = _.assign({}, query, getSortParams(params))

      slotTrakPartsServer.partLocationQuery(apiQuery)
        .then(result => {
          params.successCallback(result.Results, result.Total)
        })
        .catch(() => {
          params.failCallback()
        })
    }

    function getSortParams(params) {
      // Default pagination values if not provided
      const startRow = Number(params.startRow) || 0
      const endRow = Number(params.endRow) || startRow + 20 // default 50 rows per page
      const sort = params.sortModel && params.sortModel.length > 0 ? params.sortModel[0] : null

      let sortParams = {}
      if (sort) {
        if (sort.sort === 'asc') {
          sortParams.OrderBy = sort.colId
        } else if (sort.sort === 'desc') {
          sortParams.OrderByDesc = sort.colId
        }
      }

      return {
        Skip: startRow,
        Take: endRow - startRow,
        ...sortParams
      }
    }
  }
}

export default EmptyPartLocationsDataSource
